module.exports = __webpack_public_path__ + "static/media/bn.be00a32d.webp";